var _path, _path2, _path3, _rect, _rect2, _path4, _path5, _path6, _path7, _path8, _path9;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function Svg314(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 64,
    viewBox: "0 0 64 64",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M42 32C42 40.8366 34.8366 48 26 48C17.1634 48 10 40.8366 10 32C10 23.1634 17.1634 16 26 16C34.8366 16 42 23.1634 42 32Z",
    fill: "#E6E7E8"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54 36C54 42.6274 48.6274 48 42 48C35.3726 48 30 42.6274 30 36C30 29.3726 35.3726 24 42 24C48.6274 24 54 29.3726 54 36Z",
    fill: "#E6E7E8"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M26 40H42V48H26V40Z",
    fill: "#E6E7E8"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 19.3076,
    y: 49,
    width: 3,
    height: 12,
    rx: 1.5,
    transform: "rotate(16 19.3076 49)",
    fill: "#01E5FF"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 26.3076,
    y: 49,
    width: 3,
    height: 12,
    rx: 1.5,
    transform: "rotate(16 26.3076 49)",
    fill: "#01E5FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6538 53.5V52H43.6538V53.5H31.6538Z",
    fill: "#E3E3E3"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M43.6538 53.5C43.9493 53.5 44.2419 53.4418 44.5148 53.3287C44.7878 53.2157 45.0359 53.0499 45.2448 52.841C45.4537 52.6321 45.6195 52.384 45.7325 52.111C45.8456 51.8381 45.9038 51.5455 45.9038 51.25C45.9038 50.9545 45.8456 50.6619 45.7325 50.389C45.6195 50.116 45.4537 49.8679 45.2448 49.659C45.0359 49.4501 44.7878 49.2843 44.5148 49.1713C44.2419 49.0582 43.9493 49 43.6538 49L43.6538 50.4982C43.7525 50.4982 43.8503 50.5177 43.9415 50.5554C44.0327 50.5932 44.1156 50.6486 44.1854 50.7184C44.2552 50.7882 44.3106 50.8711 44.3484 50.9623C44.3862 51.0535 44.4056 51.1513 44.4056 51.25C44.4056 51.3487 44.3862 51.4465 44.3484 51.5377C44.3106 51.6289 44.2552 51.7118 44.1854 51.7816C44.1156 51.8514 44.0327 51.9068 43.9415 51.9446C43.8503 51.9823 43.7525 52.0018 43.6538 52.0018V53.5Z",
    fill: "#E3E3E3"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6538 54.25V55.75H46.6538V54.25H31.6538Z",
    fill: "#E3E3E3"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M46.6538 54.25C46.9493 54.25 47.2419 54.3082 47.5148 54.4213C47.7878 54.5343 48.0359 54.7001 48.2448 54.909C48.4537 55.1179 48.6195 55.366 48.7325 55.639C48.8456 55.9119 48.9038 56.2045 48.9038 56.5C48.9038 56.7955 48.8456 57.0881 48.7325 57.361C48.6195 57.634 48.4537 57.8821 48.2448 58.091C48.0359 58.2999 47.7878 58.4657 47.5148 58.5787C47.2419 58.6918 46.9493 58.75 46.6538 58.75L46.6538 57.2518C46.7525 57.2518 46.8503 57.2323 46.9415 57.1946C47.0327 57.1568 47.1156 57.1014 47.1854 57.0316C47.2552 56.9618 47.3106 56.8789 47.3484 56.7877C47.3862 56.6965 47.4056 56.5987 47.4056 56.5C47.4056 56.4013 47.3862 56.3035 47.3484 56.2123C47.3106 56.1211 47.2552 56.0382 47.1854 55.9684C47.1156 55.8986 47.0327 55.8432 46.9415 55.8054C46.8503 55.7677 46.7525 55.7482 46.6538 55.7482V54.25Z",
    fill: "#E3E3E3"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M31.6538 56.5V58H42.1538V56.5H31.6538Z",
    fill: "#E3E3E3"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M42.1538 56.5C42.4493 56.5 42.7419 56.5582 43.0148 56.6713C43.2878 56.7843 43.5359 56.9501 43.7448 57.159C43.9537 57.3679 44.1195 57.616 44.2325 57.889C44.3456 58.1619 44.4038 58.4545 44.4038 58.75C44.4038 59.0455 44.3456 59.3381 44.2325 59.611C44.1195 59.884 43.9537 60.1321 43.7448 60.341C43.5359 60.5499 43.2878 60.7157 43.0148 60.8287C42.7419 60.9418 42.4493 61 42.1538 61L42.1538 59.5018C42.2525 59.5018 42.3503 59.4823 42.4415 59.4446C42.5327 59.4068 42.6156 59.3514 42.6854 59.2816C42.7552 59.2118 42.8106 59.1289 42.8484 59.0377C42.8862 58.9465 42.9056 58.8487 42.9056 58.75C42.9056 58.6513 42.8862 58.5535 42.8484 58.4623C42.8106 58.3711 42.7552 58.2882 42.6854 58.2184C42.6156 58.1486 42.5327 58.0932 42.4415 58.0554C42.3503 58.0177 42.2525 57.9982 42.1538 57.9982V56.5Z",
    fill: "#E3E3E3"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(Svg314);
export default __webpack_public_path__ + "static/media/314.24d5ed2196497d88a588796bf70880c7.svg";
export { ForwardRef as ReactComponent };